import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Switch, Route, Redirect } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { firebase, db } from '../firebase/firebase-config';
import { types } from '../types/types';
import { getEmpresaByUid, getZonaHoraria, getLadaPorZona } from '../helpers/util';
import { LoginScreen } from '../components/auth/LoginScreen';
import { OnboardingRouter } from './OnboardingRouter';
import { HomeScreen } from '../components/home/HomeScreen';
import { SuscripcionExitosa } from '../components/onboarding/SuscripcionExitosa';
import { SuscripcionCancelada } from '../components/onboarding/SuscripcionCancelada';
import { PasoSuscripcion } from '../components/onboarding/PasoSuscripcion';

const procesarUsuario = async (user, accessToken, dispatch) => {
    const empresa = await getEmpresaByUid(user.uid);
    let completo = empresa?.onboardingCompleto || false;
    if (!completo && empresa?.id) {
        const colSnap = await db.collection(`general/${empresa.id}/consultores`).limit(1).get();
        if (!colSnap.empty) {
            completo = true;
            await db.doc(`general/${empresa.id}`).update({ onboardingCompleto: true });
        }
    }
    dispatch({
        type: types.login,
        payload: {
            uid: user.uid,
            displayName: user.displayName,
            email: user.email,
            photoURL: user.photoURL,
            accessToken: accessToken || null,
            hashtag: empresa?.id || null,
            nombre: empresa?.nombre || null,
            zonaHoraria: empresa?.zonaHoraria || getZonaHoraria(),
            ladaPais: empresa?.ladaPais || getLadaPorZona(getZonaHoraria()),
            onboardingCompleto: completo,
            suscripcionActiva: empresa?.suscripcionActiva || false,
        }
    });
};

export const AppRouter = () => {
    const dispatch = useDispatch();
    const { uid, onboardingCompleto, suscripcionActiva } = useSelector(state => state.auth);
    const [checking, setChecking] = useState(true);

    const path = window.location.pathname.replace('/app', '');
    const esSuscripcionExitosa = path.startsWith('/suscripcion-exitosa');
    const esSuscripcionCancelada = path.startsWith('/suscripcion-cancelada');

    useEffect(() => {
        let redirectHandled = false;

        firebase.auth().getRedirectResult()
            .then(async (result) => {
                if (result && result.user) {
                    redirectHandled = true;
                    const accessToken = result.credential?.accessToken;
                    await procesarUsuario(result.user, accessToken, dispatch);
                }
            })
            .catch(e => console.log('Redirect result error:', e))
            .finally(() => {
                firebase.auth().onAuthStateChanged(async (user) => {
                    if (user && !redirectHandled) {
                        try {
                            await procesarUsuario(user, null, dispatch);
                        } catch(e) {
                            console.log('procesarUsuario error:', e);
                        }
                    }
                    setChecking(false);
                });
            });
    }, [dispatch]);

    if (checking) {
        return (
            <div className="app-container" style={{ alignItems: 'center', justifyContent: 'center' }}>
                <div style={{ fontSize: 40 }}>💅</div>
                <p style={{ color: 'var(--pink-800)', marginTop: 12 }}>Cargando...</p>
            </div>
        );
    }

    if (uid && esSuscripcionExitosa) return <OnboardingRouter pasoInicial='listo' />;
    if (uid && esSuscripcionCancelada) return <SuscripcionCancelada />;

    return (
        <Router basename="/app">
            <Switch>
                {!uid && <Route path="/" component={LoginScreen} />}
                {uid && !onboardingCompleto && <Route path="/" component={OnboardingRouter} />}
                {uid && onboardingCompleto && !suscripcionActiva && <Route path="/" component={PasoSuscripcion} />}
                {uid && onboardingCompleto && suscripcionActiva && <Route path="/" component={HomeScreen} />}
                <Redirect to="/" />
            </Switch>
        </Router>
    );
};
